"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Body1Strong: function() {
        return _Body1Strong.Body1Strong;
    },
    body1StrongClassNames: function() {
        return _useBody1StrongStylesstyles.body1StrongClassNames;
    }
});
const _Body1Strong = require("./Body1Strong");
const _useBody1StrongStylesstyles = require("./useBody1StrongStyles.styles");
